export default {
	openOnload: 0,
	expandIcon: "+",
	collapseIcon: "-",
	animate: true,
};